module.exports = __webpack_public_path__ + "media/images/spotify-7578576645fc66edaf3b6541856cc04e.png";